import { List, Map } from 'immutable';
import {
  constants as jobsConstants,
  records as jobsRecords,
  types as jobsTypes,
  utils as jobUtils,
} from '@saucelabs/sl-module-jobs';

import * as types from './types';
import { types as filterTypes } from './../filters';
import {
  DEFAULT_CLOUD_TYPE,
  INITIAL_RDC_OFFSET,
  LS_LAST_CLOUD_TYPE,
} from './constants';

const initialState = Map({
  automated: List(),
  automatedLoading: true,
  cloudType: window.localStorage.getItem(LS_LAST_CLOUD_TYPE) || DEFAULT_CLOUD_TYPE,
  perfMetrics: Map(),
  rdc: List(),
  rdcError: {},
  rdcLoading: true,
  rdcMoreAvailable: false,
  rdcOffset: INITIAL_RDC_OFFSET,
});

const toggleLoader = (mutable, turnOnLoader = true) => (
  mutable
    .set('automatedLoading', turnOnLoader)
    .set('rdcLoading', turnOnLoader)
);

const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobsTypes.JOBS_GET.SUCCESS:
    case jobsTypes.AUTOMATED_JOBS_GET.SUCCESS: {
      const perfMetrics = state.get('perfMetrics');
      const jobs = payload.jobs
        .map((job) => new jobsRecords.JobRecord({
          ...job,
          performance_metrics: perfMetrics.get(job.id),
        }));
      return state.withMutations((mutable) => (
        mutable
          .set('automated', List(jobs))
          .set('automatedLoading', false)
      ));
    }
    case jobsTypes.PERF_METRICS_GET.SUCCESS: {
      const jobs = state.get('automated');
      if (payload?.items?.length && jobs?.size) {
        const perfMetrics = jobUtils.groupPerformanceByJobId(payload.items);
        const automatedJobsListIncludingPerf = jobUtils.addPerformanceMetricsInJobs({
          perfMetrics, jobs,
        });
        return state.withMutations((mutable) => (
          mutable
            .set('automated', automatedJobsListIncludingPerf)
            .set('perfMetrics', Map(perfMetrics))
        ));
      }
      return state;
    }
    case jobsTypes.UP_JOBS_GET.REQUEST:
      return state.set('rdcError', initialState.get('rdcError'));
    case jobsTypes.UP_JOBS_GET.SUCCESS: {
      const jobs = payload.entities.map((job) => new jobsRecords.RdcJobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('rdc', List(jobs))
          .set('rdcLoading', false)
          .set('rdcMoreAvailable', payload.metaData.moreAvailable)
      ));
    }
    case jobsTypes.UP_JOBS_GET.FAILURE: {
      const { response: { data: serverMessage, status: code } } = payload;
      return state.withMutations((mutable) => {
        mutable.set('rdcError', { code, serverMessage });
        mutable.set('rdcLoading', false);
      });
    }
    case types.DECREASE_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', state.get('rdcOffset') - jobsConstants.QUERY_LIMIT);
        toggleLoader(mutable, true);
      });
    case types.INCREASE_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', state.get('rdcOffset') + jobsConstants.QUERY_LIMIT);
        toggleLoader(mutable, true);
      });
    case types.CLEAR_RDC_OFFSET:
      return state.withMutations((mutable) => {
        mutable.set('rdcOffset', initialState.get('rdcOffset'));
        toggleLoader(mutable, true);
      });
    case types.SET_CLOUD_TYPE: {
      window.localStorage.setItem(LS_LAST_CLOUD_TYPE, payload);
      return state.set('cloudType', payload);
    }
    case filterTypes.TOGGLE_STATUS:
    case filterTypes.SELECT_OWNER:
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES: {
      return state.withMutations((mutable) => toggleLoader(mutable));
    }
    default:
      return state;
  }
};

export default jobsReducer;
